import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  // Direct business WhatsApp link
  const whatsappUrl = 'https://wa.me/message/EFBOOUUK2AO2K1';

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 bg-whatsapp text-white p-4 rounded-full shadow-lg hover:scale-110 hover:bg-[#1EBE5A] transition-all flex items-center justify-center group animate-pulse-slow"
    >
      <FaWhatsapp size={32} />
      <span className="absolute right-full mr-3 bg-dark-navy text-white px-4 py-2 rounded text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
